import heroImage from "../assets/figma/hero.png";
import { Container, SiteFooter, SiteHeader } from "./SiteChrome";
import { InquiryForm } from "./InquiryForm";
import { useCmsBatch } from "../hooks/useCmsBatch";
import { CmsIcon } from "../utils/cmsIcons";

const highlightsDefault = [
  { icon: "Dumbbell", title: "Premium turf", body: "Weather-proof indoor turf arenas, available year-round." },
  { icon: "CalendarDays", title: "Flexible hours", body: "Book by the hour for private sessions, team practices, or pickup games." },
  { icon: "Swords", title: "Full setup", body: "Goals, cones, and pinnies available on request." },
];

const CMS_KEYS = ["rentals-hero", "rentals-included"];

export function RentalsPage() {
  const { content } = useCmsBatch(CMS_KEYS);
  const hero = content["rentals-hero"] || {};
  const includedSection = content["rentals-included"] || {};
  const highlights = includedSection.items?.length ? includedSection.items : highlightsDefault;

  return (
    <>
      <SiteHeader />
      <main>
        <section className="section dark">
          <Container className="grid-12">
            <div className="section-copy">
              <p className="eyebrow lime"><span>01</span>Field Rentals</p>
              <h2>{hero.title || "Book the arena."}</h2>
              <p style={{ color: "var(--muted)", lineHeight: 1.8, marginTop: 16 }}>
                {hero.body || "Our premium, weather-proof turf arenas are available for teams, coaches, and private sessions — book a private tour to see availability and pricing."}
              </p>
            </div>
            <div className="media-split-image">
              <img src={hero.mediaUrl || heroImage} alt="Turf arena at Formula Soccer Center" />
            </div>
          </Container>
        </section>

        <section className="section light">
          <Container>
            <p className="eyebrow"><span>02</span>What's included</p>
            <h2 style={{ fontSize: "clamp(32px, 4vw, 52px)" }}>{includedSection.title || "Everything you need to play."}</h2>
            <div className="value-grid">
              {highlights.map((item) => (
                <div key={item.title} className="value-card">
                  <div className="value-card-icon"><CmsIcon name={item.icon} size={20} strokeWidth={1.5} /></div>
                  <h3>{item.title}</h3>
                  <p>{item.body}</p>
                </div>
              ))}
            </div>
          </Container>
        </section>

        <section className="section dark">
          <Container>
            <p className="eyebrow lime"><span>03</span>Request a rental</p>
            <h2 style={{ fontSize: "clamp(28px, 3.5vw, 42px)" }}>Tell us what you need.</h2>
            <InquiryForm
              source="field_rental"
              submitLabel="Request availability"
              successMessage="Thanks! Our team will follow up with availability and pricing."
              messagePlaceholder="Preferred dates, times, and group size (optional)"
            />
          </Container>
        </section>
      </main>
      <SiteFooter />
    </>
  );
}
